import { useEffect } from 'react'

/**
 * Sets the browser tab favicon to the given URL.
 * Falls back to /vite.svg if no URL is provided.
 */
export function useFavicon(url?: string | null) {
  useEffect(() => {
    const href = url || '/vite.svg'
    let link = document.querySelector<HTMLLinkElement>('link[rel="icon"]')
    if (!link) {
      link = document.createElement('link')
      link.rel = 'icon'
      document.head.appendChild(link)
    }
    link.href = href
    // Remove type restriction so browser accepts PNG/JPG favicons (not just SVG)
    link.removeAttribute('type')
  }, [url])
}
